import i18n from '../../i18n/index'
export default {
  data() {
    return {
      headers: [
        {
          text: i18n.t('headers.nro-order'),
          sortable: false,
          value: "number"
        },
        { text: i18n.t('headers.provider'), value: "providerId", sortable: false },
        { text: "Total documentos", value: "providerId", sortable: false },
        {
          text: "Total cuota moderadora",
          value: "providerId",
          sortable: false
        }
      ],
      itemsData: []
    };
  },
  props: {
    logsList: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    logsList() {
      this.itemsData = this.logsList;
    }
  },
  created() {
    this.itemsData = this.logsList;
  },
  methods: {}
};
